import "../css/style.css";
import $ from "jquery";

import Slider from "./modules/slider.js";
import Carousel from "./modules/carousel.js";
import Select from "./modules/select.js";
import SelectM from "./modules/selectM.js";
import Search from "./modules/search.js";
import SearchM from "./modules/searchM.js";
import Navigation from "./modules/navigation.js";
import ChangeNav from "./modules/changeNav.js";

var slider = new Slider();
var select = new Select();
var selectM = new SelectM();
var carousel_1 = new Carousel(".carousel-1");
var carousel_2 = new Carousel(".carousel-2");
var search = new Search();
var searchM = new SearchM();
var navigation = new Navigation();
var changeNav = new ChangeNav();